import React from 'react';
import SEO from '../components/SEO';
import usePage from '../hooks/usePage';

const DEFAULT_CONTENT = `<h2>Why Choose St. Andrews World School, Indirapuram?</h2>

<p>St. Andrews World School, Indirapuram offers more than just academics. We are committed to the holistic development of every student, ensuring they grow intellectually, emotionally, socially, and physically.</p>

<p><strong>Holistic Development:</strong> Our approach goes beyond textbooks. We focus on nurturing every aspect of a child&rsquo;s personality, from physical fitness and emotional intelligence to creativity and critical thinking.</p>

<p><strong>Tailored Learning:</strong> We recognise that every child is unique. Our teaching methodologies are designed to cater to individual learning styles, ensuring that each student receives the attention and support they need to thrive.</p>

<p><strong>State-of-the-Art Campus:</strong> Our campus is equipped with modern facilities, including dedicated spaces for dance, music, and various programmes that foster creativity, self-expression, and talent development.</p>`;

const WhyUs = () => {
  const title = 'Why Choose St. Andrews World School, Indirapuram?';
  const pageData = usePage('why-us', { content: DEFAULT_CONTENT });

  return (
    <>
      <SEO
        slug="why-us"
        title={title}
        description="Why choose St. Andrews World School, Indirapuram."
        keywords="Why us, SAWS Indirapuram, best school in Indirapuram"
      />

      <section className="page-hero">
        {!pageData.loading && (
        <img
            src={pageData.bannerImage || '${process.env.PUBLIC_URL}/images/page-banners/why-choose-us.jpg'}
            alt={title}
            className="page-hero-img"
            loading="eager"
          />
        )}
        <div className="page-hero-content">
          <div className="container">
            <div className="page-hero-inner">

            </div>
          </div>
        </div>
      </section>

      <section className="section bg-white">
        <div className="container">
          <div className="max-w-[1200px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
            <div className="order-1">
              <img src={`${process.env.PUBLIC_URL}/images/IMG_1928.webp`} alt={title} className="w-full rounded-2xl shadow-lg" loading="lazy" />
            </div>
            <div className="order-2">
              <div className="text-body leading-relaxed" dangerouslySetInnerHTML={{ __html: pageData.content || DEFAULT_CONTENT }} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default WhyUs;